import { useEffect } from "react";

type Props = {
  to: string;
};

export const Redirect = ({ to }: Props) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);

  return null;
};
